import client from './client';

export const porkbunApi = {
  async listDomains() {
    const { data } = await client.get('/api/admin/porkbun');
    return data;
  },

  async listRecords(domain) {
    const { data } = await client.get(`/api/admin/porkbun/${encodeURIComponent(domain)}/records`);
    return data;
  },

  async createRecord(domain, record) {
    const { data } = await client.post(
      `/api/admin/porkbun/${encodeURIComponent(domain)}/records`,
      record
    );
    return data;
  },

  async updateRecord(domain, id, record) {
    const { data } = await client.put(
      `/api/admin/porkbun/${encodeURIComponent(domain)}/records/${encodeURIComponent(id)}`,
      record
    );
    return data;
  },

  async deleteRecord(domain, id) {
    const { data } = await client.delete(
      `/api/admin/porkbun/${encodeURIComponent(domain)}/records/${encodeURIComponent(id)}`
    );
    return data;
  },

  async route53Status(domain) {
    const { data } = await client.get(
      `/api/admin/porkbun/${encodeURIComponent(domain)}/route53-status`
    );
    return data;
  },

  async transferFromRoute53(domain) {
    const { data } = await client.post(
      `/api/admin/porkbun/${encodeURIComponent(domain)}/transfer-from-route53`
    );
    return data;
  },
};
